import Model  from '@/util/models';
import Dapil  from './Dapil';
import Partai from './Partai';


export default class Kompetisi extends Model { 
    backend = '/frc/hitung/'; 
       
    kompetisis(params){
        return this.api.get(this.backend + 'kompetisis', params);
    }

    kompetisisByKelurahan(params){
        return this.api.get(this.backend + 'kompetisis-by-kelurahan', params);
    }
    
    kompetisi(params){
        return this.api.get(this.backend + 'kompetisi', params);
    }
    
    xlTemplate(params){
        return this.api.get(this.backend + 'xl-template', params);
    }
    
    areas(params){
        return this.api.get(this.backend + 'areas', params);
    }
    
    kelurahans(params){
        return this.api.get(this.backend + 'kelurahans', params);
    }
    
    surat(params, firstime = true){
        return this.api.get(firstime ? '/frc/hitung/surat':'/frc/hitung/surat-min', params);
    }  
    
    partais(params){
      let model = new Partai();
      return model.all(params);
    }
    
    getImg(params){
        return this.api.get('/frc/image/get-img', params);
    }
    
    getThumb(params){
        return this.api.get('/frc/image/get-thumb', params);
    }
    
    getC1Download(params){
        return this.api.get(this.backend + 'c1-download', params);
    }
}

